// extracted by mini-css-extract-plugin
module.exports = {"Label":"Label","isWarning":"isWarning","isError":"isError","isRecommended":"isRecommended"};